module.exports = __webpack_public_path__ + "static/media/Library_3.38a5d170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_3.png
// module id = 1290
// module chunks = 3